import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputTextComponent } from 'src/app/shared/components/inputs/input-text/input-text.component';
import { InputToggleComponent } from 'src/app/shared/components/inputs/input-toggle/input-toggle.component';

@Component({
  selector: 'app-new-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputTextComponent,
    InputToggleComponent,
  ],
  templateUrl: './new-form.component.html',
  styleUrl: './new-form.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewFormComponent implements OnInit {
  @Input() form!: FormGroup;

  ngOnInit() {
   // this.form.addControl('nomenclatura', new FormControl('', [Validators.required]));
    this.form.addControl('parametro', new FormControl('', [Validators.required]));
    this.form.addControl('definizione', new FormControl('', [Validators.required]));
    this.form.addControl('unitaDiMisura', new FormControl('', [Validators.required]));
    this.form.addControl('note', new FormControl('', []));
   // this.form.addControl('isCodificato', new FormControl(false, []));
  }
}
